/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractSnapshotFormComponent,
  formSchemaBuilderByEntityConfig,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getFormStateSnapshotValue,
  getRouteInitData,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { AutocompleteLoadMoreEvent, getControlValue } from '@gh/core-ui';
import { assign, without } from 'lodash';
import { CSMasterBusinessService } from '../../../resources/cs-master-business.service';
import { CS_MASTER_CC_INFO_ENTITY_CONFIG, CSMasterCCInfo } from '../../../resources/cs-master.model';

@Component({
  selector: 'gh-cs-master-detail-cc-form',
  template: require('./cs-master-detail-cc-form.component.html'),
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsMasterDetailCCFormComponent extends AbstractSnapshotFormComponent<CSMasterCCInfo>
  implements OnInit {

  @Input() costCenters?: CSMasterCCInfo[];

  constructor(private route: ActivatedRoute,
              private formStateBuilder: FormStateBuilder,
              private businessService: CSMasterBusinessService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    assign(this, getRouteInitData(this.route));
  }

  loadCC($event: AutocompleteLoadMoreEvent): void {
    const costCenter = getControlValue(this.form.group, 'costCenter');
    $event.load(this.businessService.loadCC(
      $event.query,
      without(
        (this.costCenters || [])
          .map((cc) => getFormStateSnapshotValue(cc.info).costCenter)
          .filter(Boolean)
          .map((ccItem) => ccItem.id),
        costCenter && costCenter.id)));
  }

  protected buildForm(snapshot: FormStateSnapshot<CSMasterCCInfo>): FormState<CSMasterCCInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        ...formSchemaBuilderByEntityConfig(getFormStateSnapshotValue(snapshot), CS_MASTER_CC_INFO_ENTITY_CONFIG),
      },
    });
  }
}
